import React from 'react';
import { Dialog, DialogProps, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface DialogWithCloseProps extends DialogProps {
  onClose: () => void;
}

const DialogWithClose: React.FC<DialogWithCloseProps> = ({ children, onClose, ...props }) => {
  return (
    <Dialog {...props}>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      {children}
    </Dialog>
  );
};

export default DialogWithClose;
